import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { EditAddressType } from './schema';
import Actions from './Actions';
import Place from './Place';
import { FormPropsInterface } from './FormTypes';

function Form({
  isLoading,
  renderLocation,
  onConfirm,
  onCancel,
}: FormPropsInterface) {
  const { handleSubmit } = useFormContext<EditAddressType>();

  return (
    <form
      data-testid="form-createJourney"
      onSubmit={handleSubmit((data) => onConfirm(data))}
    >
      <FuelFlex defaultProps={{ flexDirection: 'column', gap: 'km6' }}>
        <Place flow="pickup" />
        <Place flow="delivery" hasMarginTop />
        <Actions
          isLoading={isLoading}
          renderLocation={renderLocation}
          onCancel={onCancel}
        />
      </FuelFlex>
    </form>
  );
}

export default Form;
